import { CheckCircle2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { PresetFilters } from '@/types/filters';

interface Props {
  config: PresetFilters;
  value: string;
  onChange: (key: string, value: string) => void;
}

export const PresetFiltersView = ({ config, value, onChange }: Props) => {
  const handleOptionClick = (optionValue: string) => {
    // If the same option is clicked, ignore it (no deselection)
    if (value === optionValue) {
      return;
    }

    // Otherwise, select the new option (deselecting the previous one)
    onChange(config.name, optionValue);
  };

  const getVariant = (
    optionValue: string,
    optionVariant?: 'default' | 'outlineDestructive' | 'outlineWarning'
  ) => {
    const isSelected = value === optionValue;

    switch (optionVariant) {
      case 'outlineDestructive':
        return isSelected ? 'default' : 'outlineDestructive';
      case 'outlineWarning':
        return isSelected ? 'default' : 'outlineWarning';
      case 'default':
        return isSelected ? 'default' : 'outline';
    }

    return optionVariant;
  };

  return (
    <div className="flex items-center gap-2">
      {config.options.map(option => (
        <Button
          type="button"
          key={option.value}
          variant={getVariant(option.value, option.variant)}
          size="sm"
          onClick={() => handleOptionClick(option.value)}
          disabled={option.resolved}
          className={cn('transition-all duration-200', option.resolved && 'opacity-100')}
        >
          {option.resolved && <CheckCircle2 className="h-3.5 w-3.5 animate-pulse text-green-500" />}
          {option.label}
        </Button>
      ))}
    </div>
  );
};
